import { IResourceComponentsProps } from "@refinedev/core";
import { Edit, useStepsForm } from "@refinedev/antd";
import { Form, Button } from "antd";
import { ICredential, IUser } from "../../interfaces";
import { FormList } from "./form";

export const CredentialEdit: React.FC<IResourceComponentsProps> = () => {
  const { formProps, saveButtonProps, queryResult } = useStepsForm<ICredential>();
  return (
    <>
      <Edit
        isLoading={queryResult?.isFetching}
        saveButtonProps={saveButtonProps}
        headerButtons={<Button onClick={() => history.back()}>Back</Button>}
      >
        <Form
          {...formProps}
          style={{ marginTop: 30 }}
          layout="vertical"
          initialValues={{
            ...formProps.initialValues,
          }}
        >
          <FormList formProps={formProps} />
        </Form>
      </Edit>
    </>
  );
};
